import { 
    SET_SERVICE_RULE_CONFIG, 
    SET_SERVICE_RULE_LOADING, 
    SET_SERVICE_RULE_ERROR,
    UPDATE_SERVICE_RULE_CONFIG,
    CLEAR_SERVICE_RULE_ERROR,
    CLEAR_SERVICE_RULE_DATA,
    CLEAR_ALL_SERVICE_RULE_DATA,
    ServiceRuleMasterActionType 
} from '@store/types/serviceRuleMasterTypes';

export interface ServiceRuleMasterState {
    configs: {
        [configName: string]: {
            data: any;
            loading: boolean;
            error: string | null;
            lastUpdated: number | null;
        };
    };
}

const initialState: ServiceRuleMasterState = {
    configs: {}
};

const serviceRuleMasterReducer = (
    state = initialState,
    action: ServiceRuleMasterActionType
): ServiceRuleMasterState => {
    switch (action.type) {
        case SET_SERVICE_RULE_CONFIG:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        ...state.configs[action.payload.configName],
                        data: action.payload.data,
                        loading: false,
                        error: null,
                        lastUpdated: Date.now()
                    }
                }
            };

        case SET_SERVICE_RULE_LOADING:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        ...state.configs[action.payload.configName],
                        loading: action.payload.loading
                    }
                }
            };

        case SET_SERVICE_RULE_ERROR:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        ...state.configs[action.payload.configName],
                        loading: false,
                        error: action.payload.error
                    }
                }
            };

        case UPDATE_SERVICE_RULE_CONFIG: {
            const currentConfig = state.configs[action.payload.configName]?.data || {};
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        ...state.configs[action.payload.configName],
                        data: {
                            ...currentConfig,
                            ...action.payload.updates
                        },
                        lastUpdated: Date.now()
                    }
                }
            };
        }

        case CLEAR_SERVICE_RULE_ERROR:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        ...state.configs[action.payload.configName],
                        error: null
                    }
                }
            };

        case CLEAR_SERVICE_RULE_DATA:
            return {
                ...state,
                configs: {
                    ...state.configs,
                    [action.payload.configName]: {
                        data: null,
                        loading: false,
                        error: null,
                        lastUpdated: null
                    }
                }
            };

        case CLEAR_ALL_SERVICE_RULE_DATA:
            return {
                ...state,
                configs: {}
            };

        default:
            return state;
    }
};

export default serviceRuleMasterReducer;